import App from './App.svelte';
import * as viewportObserver from './viewportObserver';

viewportObserver.init();
const app = new App({ target: document.body });

export default app;